<template>
  <el-dialog
    v-loading="loading"
    :visible.sync="visible"
    :title="$l('table_label_add_subscribe') || '添加订阅'"
    show-close
    top="5vh"
    width="800px"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
    destroy-on-close
  >
    <el-form ref="form" :model="form" size="small" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('table_label_subsribeAccount') || '订阅账号'"
          >
            <el-input
              v-model="subsribeAccount"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-radio-group v-model="subsribeType">
            <el-radio :label="1">{{
              $l('table_label_receive') || '收件'
            }}</el-radio>
            <el-radio :label="2">{{
              $l('table_label_copyTo') || '抄送'
            }}</el-radio>
          </el-radio-group>
          <span class="ml-4">
            <el-button size="small" type="success" @click="addSubsribe">
              {{ $l('INDEX.btn_add') || '新增' }}</el-button
            >
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$l('table_label_receive') || '收件'">
            <el-select
              v-model="form.receiveList"
              multiple
              filterable
              allow-create
              style="width: 100%"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$l('table_label_copyTo') || '抄送'">
            <el-select
              v-model="form.copyToList"
              multiple
              filterable
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge class="ml-2">
        <el-button type="primary" size="small" @click="confirm()">
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
    </span>
  </el-dialog>
</template>
<script>
const initForm = {
  receiveList: [],
  copyToList: [],
}
export default {
  props: {
    templateId: { type: String, default: '' },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      form: {
        ...initForm,
      },
      loading: false,
      subsribeAccount: '',
      subsribeType: 1,
    }
  },
  mounted() {
    this.init()
  },
  computed: {},
  methods: {
    init() {
      this.$api
        .sysMessageSubscribeDetailApi({
          templateId: this.templateId,
        })
        .then((res) => {
          this.form.templateId = res.body.templateId
          this.form.receiveList = res.body.receiveList || []
          this.form.copyToList = res.body.copyToList || []
        })
        .catch(() => {})
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    addSubsribe() {
      if (this.subsribeType == 1) {
        if (this.form.copyToList.indexOf(this.subsribeAccount) != -1) {
          this.$message({
            showClose: true,
            message: this.$l('tips_copyTo_has') || '抄送中含有该账号',
            type: 'warning',
          })
          return
        }
        if (this.form.receiveList.indexOf(this.subsribeAccount) != -1) {
          return
        }
        this.form.receiveList = this.form.receiveList.concat(
          this.subsribeAccount
        )
      } else {
        if (this.form.receiveList.indexOf(this.subsribeAccount) != -1) {
          this.$message({
            showClose: true,
            message: this.$l('tips_receive_has') || '接收中含有该账号',
            type: 'warning',
          })
          return
        }
        if (this.form.copyToList.indexOf(this.subsribeAccount) != -1) {
          return
        }
        this.form.copyToList = this.form.copyToList.concat(this.subsribeAccount)
      }
    },
    confirm() {
      this.loading = true
      this.$api
        .sysMessageSubscribeSaveApi({
          ...this.form,
        })
        .then((res) => {
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.loading = false
            this.close()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
